<template>
  <div>
    <custom-callout
      :border-color="'gray'"
      class-main="mt-1 rounded"
      :has-toggle="false"
      :opened="false"
    >
      <div class="row py-2 mr-md-0 align-items-center mobile-only">
        <div class="col-md-1">
          <div
            class="
                d-flex
                flex-column
                font-weight-bold
                color-black
                mt-n5
                ml-n4
                mt-sm-n5
                ml-sm-n4
              "
          >
            <div class="dot text-center color-white">
              <i class="fa fa-phone fa-flip-horizontal" />
            </div>
          </div>
        </div>
        <div class="col-md-10">
          <div class="row mt-3">
            <div class="col-md-3">
              <div class="color-gray-6 font-14">
                {{ title(contact) }}
              </div>
              <div class="color-black font-16">
                {{ fullName(contact) }}
              </div>
            </div>
            <div class="col-md-3 mb-4">
              <div class="color-gray-6 font-14">Departamento:</div>
              <div class="color-black font-16">
                {{ contact.department | empty }}
              </div>
            </div>
            <div class="col-md-3 mb-4">
              <div class="color-gray-6 font-14">Posición:</div>
              <div class="color-black font-16">
                {{ contact.position | empty }}
              </div>
            </div>
            <div class="col-md-3" style="min-width: 200px; max-width: 250px;">
              <div class="color-gray-6 font-14">Correo Electrónico:</div>
              <div class="color-black font-16">
                {{ contact.email | empty }}
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-md-3">
              <div class="color-gray-6 font-14">Celular:</div>
              <div class="color-black font-16">
                {{ contact.cellPhone | formatPhone }}
              </div>
            </div>
            <div class="col-md-3">
              <div class="color-gray-6 font-14">Hogar:</div>
              <div class="color-black font-16">
                {{ contact.homePhone | formatPhone }}
              </div>
            </div>
            <div class="col-md-3">
              <div class="color-gray-6 font-14">Trabajo:</div>
              <div class="color-black font-16">
                {{ contact.workPhone | formatPhone }}
              </div>
            </div>
            <div class="col-sm">
              <div class="color-gray-6 font-14">Fax:</div>
              <div class="color-black font-16">
                {{ contact.fax | formatPhone }}
              </div>
            </div>
            <div class="col-sm">
              <div class="color-gray-6 font-14">Ext:</div>
              <div class="color-black font-16">
                {{ contact.workPhoneExt }}
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-1">
          <div class="col-12 mb-4 d-flex justify-content-end ml-n3">
            <drop-down :items="actionItems(contact)" />
          </div>
        </div>
      </div>
    </custom-callout>
    <div v-if="showEditForm" class="bg-light-gray rounded py-1 mt-3">
      <div class="row m-2">
        <add-location-service-contact
          v-model="model"
          :location-id="locationId"
          @cancel="onCancel()"
          @save="submit()"
        />
      </div>
    </div>
  </div>
</template>

<script>
import CustomCallout from 'custom-callout';
import DropDown from 'dropdown';
import AddLocationServiceContact from './AddLocationServiceContact';

export default {
  name: 'LocationServiceContactRow',
  components: {
    CustomCallout,
    DropDown,
    AddLocationServiceContact,
  },
  props: {
    contact: {
      type: Object,
      default: () => ({}),
    },
    locationId: {
      type: Number,
      default: () => 0,
    },
  },
  data() {
    return {
      model: {},
      showEditForm: false,
    };
  },
  computed: {
    fullName() {
      return (item) => {
        return `${item.nameFirst || ''} ${item.nameInitial ||
          ''} ${item.nameLastPaternal || ''} ${item.nameLastMaternal ||
          ''}`.trim();
      };
    },
    title() {
      return (item) => {
        return item.isPrimaryContactFlag
          ? 'Contacto Primario:'
          : 'Contacto Secundario:';
      };
    },
    actionItems() {
      return (item) => {
        return [
          {
            label: 'Editar',
            icon: 'fas fa-edit color-green',
            border: item.isPrimaryContactFlag ? '' : 'bottom',
            click: () => this.onEditContact(item),
          },
          {
            label: 'Eliminar',
            icon: 'fas fa-times-circle color-red',
            visible: !item.isPrimaryContactFlag,
            click: () => this.onEditContact(item),
          },
        ];
      };
    },
  },
  methods: {
    cancelAddorEditContact() {
      this.$emit('on-cancel-add-or-edit-contact');
    },
    onEditContact(contact) {
      if (contact) {
        this.showEditForm = true;
        this.model = {
          id: contact.id,
          locationId: this.locationId,
          isPrimaryContactFlag: contact.isPrimaryContactFlag,
          name: contact.nameFirst,
          initial: contact.nameInitial,
          lastName: contact.nameLastPaternal,
          secondSurname: contact.nameLastMaternal,
          workDepartmentName: contact.department,
          workPositionTitle: contact.position,
          email: contact.email,
          telephoneMobileNo: contact.cellPhone,
          telephoneWorkNo: contact.workPhone,
          workPhoneExt: contact.workPhoneExt,
          telephoneWorkFaxNo: contact.fax,
          telephoneHomeNo: contact.homePhone,
        };
      }
    },
    submit() {
      this.showEditForm = false;
      this.clearModel();
      this.$emit('reload');
    },
    onCancel() {
      this.showEditForm = false;
      this.clearModel();
    },
    clearModel() {
      this.model = {
        locationId: null,
        isPrimaryContactFlag: null,
        name: null,
        initial: null,
        lastName: null,
        secondSurname: null,
        workDepartmentName: null,
        workPositionTitle: null,
        email: null,
        telephoneMobileNo: null,
        telephoneWorkNo: null,
        workPhoneExt: null,
        telephoneWorkFaxNo: null,
        telephoneHomeNo: null,
      };
    },
  },
  filters: {
    formatPhone(phone) {
      if (!phone) return '-';
      if (phone?.trim() > 0) {
        return (
          '(' +
          phone.substring(0, 3) +
          ') ' +
          phone.substring(3, 6) +
          '-' +
          phone.substring(6)
        );
      } else {
        return phone?.trim().length === 0 ? '-' : phone;
      }
    },
  },
};
</script>

<style scoped lang="scss">
@import '~@/shared/scss/config/colors.scss';
.dot {
  background-color: map-get($colors, 'orange');
  box-shadow: 0px 3px 6px #00000029;
  margin: 2px;
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border-style: solid;
  border-width: 3px;
  border-color: map-get($colors, 'white');
  display: inline-block;
}
.ml-2-5 {
  margin-left: 2.5rem;
}
.mln-1-5 {
  margin-left: -1.5rem;
}
.mr-n6 {
  margin: 0 -6rem;
}

@media screen and (max-width: 768px) {
  .desktop-drop-down {
    display: none !important;
  }
  .mobile-drop-down {
    display: block !important;
    width: 100%;
  }

  ::v-deep #dropdownMenuButton {
    width: 97% !important;
    display: block !important;
  }

  ::v-deep div.dropdown-menu {
    width: 80% !important;
    top: 0 !important;
  }
}
</style>
